import { render } from "./Carriers.vue?vue&type=template&id=21dd8e78"
import script from "./Carriers.vue?vue&type=script&lang=js"
export * from "./Carriers.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mw/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__